const desktop = {
  sourceWidth: 1920,
  aspectRatio: 1440 / 690,
  breakpoints: [1280, 1440, 1680, 1920],
  backgroundColor: '#EDEDED',
  layout: 'constrained',
  options: {
    fitIn: true,
  },
}

const mobile = {
  sourceWidth: 720,
  aspectRatio: 480 / 317,
  breakpoints: [360, 480, 720],
  backgroundColor: '#EDEDED',
  layout: 'constrained',
  options: {
    fitIn: true,
  },
}

module.exports = {
  'carousel.desktop': {
    sourceWidth: 2704,
    aspectRatio: 169 / 50,
    breakpoints: [768, 1352, 2704],
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'carousel.mobile': {
    sourceWidth: 896,
    aspectRatio: 16 / 10,
    breakpoints: [320, 375, 423, 896],
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'heroCarousel.desktop': {
    sourceWidth: 2680,
    aspectRatio: 1340 / 296,
    breakpoints: [768, 1024, 1280, 1340, 2680],
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'heroCarousel.tablet': {
    sourceWidth: 1536,
    aspectRatio: 768 / 296,
    breakpoints: [450, 640, 768, 1536],
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'heroCarousel.mobile': {
    sourceWidth: 900,
    aspectRatio: 450 / 296,
    breakpoints: [320, 375, 450, 900],
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'staticBanner.desktop': desktop,
  'staticBanner.mobile': mobile,
  'showcaseBanner.desktop': desktop,
  'showcaseBanner.mobile': mobile,
  'product.summary': {
    sourceWidth: 480,
    aspectRatio: 1,
    width: 360,
    breakpoints: [250, 360, 480],
    layout: 'constrained',
    fadeIn: false,
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'product.details': {
    sourceWidth: 720,
    aspectRatio: 1,
    width: 720,
    breakpoints: [250, 360, 480, 720],
    layout: 'constrained',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'product.miniature': {
    sourceWidth: 720,
    aspectRatio: 1,
    width: 100,
    breakpoints: [50, 100, 150],
    layout: 'constrained',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'offers.mobile': {
    sourceWidth: 640,
    aspectRatio: 2.3,
    breakpoints: [250, 360, 480, 720],
    layout: 'constrained',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'offers.desktop': {
    sourceWidth: 640,
    aspectRatio: 2.3,
    width: 317,
    breakpoints: [1280, 1440, 1680, 1920],
    layout: 'fullWidth',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'grid-banner.desktop': {
    width: 205,
    aspectRatio: 1,
    breakpoints: [1280, 1440, 1680, 1920],
    layout: 'fixed',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: false,
    },
  },
  'grid-banner.mobile': {
    aspectRatio: 1,
    width: 96,
    breakpoints: [250, 360, 480, 720],
    layout: 'fixed',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: false,
    },
  },
  'club.desktop': {
    sourceWidth: 2704,
    aspectRatio: 436 / 201,
    breakpoints: [768, 1352, 2704],
    backgroundColor: '#EDEDED',
    layout: 'fixed',
    options: {
      fitIn: true,
    },
  },
  'club.mobile': {
    sourceWidth: 100,
    width: 100,
    aspectRatio: 100 / 92,
    breakpoints: [320, 375, 423, 896],
    backgroundColor: '#EDEDED',
    layout: 'fixed',
    options: {
      fitIn: true,
    },
  },
  'catimages.desktop': {
    width: 150,
    breakpoints: [150],
    aspectRatio: 1,
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'catimages.mobile': {
    width: 80,
    breakpoints: [80],
    aspectRatio: 1,
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
}
